module.exports = __webpack_public_path__ + "img/604_1.247c6737.jpg";